// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_conf__Config from "../../conf/lib/Config.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Fetch from "melange-fetch/Fetch.js";
import * as LocalStorage from "../../util/lib/LocalStorage.js";

function addIdentityHeader(headers) {
  const context = LocalStorage.getItem("selected-identity-context");
  if (context !== undefined) {
    headers.append("Identity-Context", context);
  }
  const tenant = LocalStorage.getItem("selected-identity-tenant");
  if (tenant !== undefined) {
    headers.append("Identity-Tenant", tenant);
    return ;
  }
  
}

function addDefaultHeaders(headers) {
  headers.append("Content-Type", "application/json");
  headers.append("Accept", "application/json");
  addIdentityHeader(headers);
  return headers;
}

function get(headers, url) {
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const headers$1 = addDefaultHeaders(Belt__Belt_Option.getWithDefault(headers, new Headers()));
  return fetch(cfg.app_url + url, Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers$1), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined));
}

function post(headers, url, payload) {
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const headers$1 = addDefaultHeaders(Belt__Belt_Option.getWithDefault(headers, new Headers()));
  return fetch(cfg.app_url + url, Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers$1), Caml_option.some(JSON.stringify(payload)), undefined, undefined, undefined, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
}

function put(headers, url, payload) {
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const headers$1 = addDefaultHeaders(Belt__Belt_Option.getWithDefault(headers, new Headers()));
  return fetch(cfg.app_url + url, Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers$1), Caml_option.some(JSON.stringify(payload)), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined));
}

export {
  addIdentityHeader ,
  addDefaultHeaders ,
  get ,
  post ,
  put ,
}
/* Buhta_conf__Config Not a pure module */
